import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';

import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

import Bs4GenericField from './Bs4GenericField'
import Bs4MainDispatch from '../../Bs4MainDispatch';
import Bs4Kartoteka from '../../Bs4Kartoteka';

export default class Bs4Textarea extends Bs4GenericField {  

  canCloseCriteria = false;
  
  setValueBs4(value) {
    this.setValue(value || '');
  }

  checkSuggestionBs4 = (e) => {
    const newValue = e.target.value;

    // this.closeSuggestionBs4();
    let startPosition = -1;
    const position = e.target.selectionStart;
    if (! (position >= 0)) return;
          
    const v1 = newValue.slice(0, position);
    startPosition = v1.lastIndexOf('@');
    if (startPosition < v1.lastIndexOf(' ')) return;
    if (startPosition < 0) return;

    let suggestionBs4Key = newValue.slice(startPosition);
    const i2 = suggestionBs4Key.indexOf(' ');
    if (i2 >= 0) {
      suggestionBs4Key = suggestionBs4Key.slice(0, i2);		
    }					
    
    if (suggestionBs4Key?.length > 3) {
      const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
      bs4Kartoteka.suggestionBs4 = (message) => {
        console.log('... suggestionBs4 ...', message)
        if (Array.isArray(message._Komunikat)) {
          const suggestions = [];
          message._Komunikat.map(suggestion => {
            if (suggestion.items) {
              suggestions.push(...suggestion.items)
            } else {
              suggestions.push(suggestion)
            }
          })

          this.setSuggestionBs4(suggestions);
        }
      }
      this.suggestionBs4Key = suggestionBs4Key;
      Bs4MainDispatch.commandParser('Bs4Suggest', {currFormId: this.props.formId, query: suggestionBs4Key}, this.bs4KartotekaId); 
    }
  }
  
  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue() || '');
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    this.refFocus = React.useRef();  
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const refMenuFirst = React.useRef();
    const refMenuLast = React.useRef();
    const [focus, setFocus] = React.useState(false);
    const theme = useTheme()

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue() || '');
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);

    const handleChange = (e) => {
      this.setValue(e.target.value);
      console.log('...Bs4Form...Bs4Textarea...Change...', this.getLabelPlane(), this.getValue())
      setOpen(false)
      this.setSuggestionBs4 = (suggestions) => {
        // const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
        // ??? delete bs4Kartoteka.suggestionBs4;
        setOptions(suggestions)
        setOpen(true)
      }
      this.checkSuggestionBs4(e);
    }

    const handleMenuClick = (suggestionBs4) => {
      const value = this.getValue();
      this.setValue(value.replace(this.suggestionBs4Key, suggestionBs4.value));
      setOpen(false)
      this.refFocus.current.focus();
    }

    const handleKeyDownTextField = (e) => {
      if (refMenuFirst.current && open && (e.key === "ArrowDown" || e.key === "ArrowUp") && options.length === 1) refMenuFirst.current.focus();
      else if (refMenuLast.current && open && e.key === "ArrowUp") refMenuLast.current.focus();
      else if (refMenuFirst.current && open && e.key === "ArrowDown") refMenuFirst.current.focus();
    }

    const handleKeyDownMenuList = (e) => {
      if (e.key === "Escape") this.refFocus.current.focus();
      //["ArrowDown", "ArrowUp", "Enter"]
    }

    const handleFocusBlur = (event) => {
      let newFocus = event.type === 'focus';      
            
      if (event.type === 'blur') {
        newFocus = Boolean(this.getParentNodeById(this.getFieldDialogId(), event.relatedTarget) || this.getParentNodeById(this.getElementId(), event.relatedTarget));
      }
      if (focus != newFocus) {
        //this.trigger(newFocus ? Bs4GenericField.FOCUS_ENTER : Bs4GenericField.FOCUS_LEAVE, this);
        setFocus(newFocus);
      }  
    }

    const handleEmojiClick = (emojiData, event) => {
      console.log('... EmojiClick ...', emojiData, event)
      setValue(value+emojiData.emoji)
    }

    return (
      <React.Fragment>
        <TextField 
          id={formField.getElementId()}   
          inputRef={formField.refFocus}
          fullWidth
          multiline          
          //rows={9}
          maxRows={12}
          label={<formField.Bs4Label/>} 
          value={value}
          onChange={handleChange}
          error={error.error}
          helperText={error.helperText}
          onKeyDown={handleKeyDownTextField}
          autoComplete='off'
          onFocus={handleFocusBlur}
          onBlur={handleFocusBlur}
          slotProps={{
            inputLabel: formField.props.field.hideLabel ? {sx:{display:'none'}} : null,
            htmlInput: {readOnly: formField.readOnly},
            input: {
              disableUnderline: formField.readOnly,
          },
        }}
        />
        <Popper          
          sx={{zIndex: theme.zIndex.modal}}
          open={open && focus}
          anchorEl={formField.refFocus.current}
          placement="bottom" //"bottom-start"
          onFocus={handleFocusBlur}
          onBlur={handleFocusBlur}
        >
          <Paper id={formField.getFieldDialogId()}>
            <MenuList 
              dense
              onKeyDown={handleKeyDownMenuList}
            >
              {options.map((option, index) => {
                // console.log('... TextArea !!!! ...', options, option, index);
                const refFirst = index === 0 ? {ref:refMenuFirst} : {}
                const refLast = index === options.length - 1 && options.length > 1 ? {ref:refMenuLast} : {}
                return (
                <MenuItem key={index} {...refFirst} {...refLast} onClick={() => handleMenuClick(option)}>
                  <ListItemText inset>{option.key}</ListItemText>
                </MenuItem>                  
              )})}                  
            </MenuList>
          </Paper>            
        </Popper>
      </React.Fragment>
    );
  }
}